import React from "react";
import { View, Text, StyleSheet } from "../platformComponents";
import { IS_WEB, tranformPx, TKycInformationKeyValueItem } from "@adgm/libs";

interface IKeyValueTableProps {
  data: TKycInformationKeyValueItem[];
}

/**
 * 支持Web和App端不同样式展示
 * 用于展示kyc information的键值对信息
 */
export const KycKeyValueTable: React.FC<IKeyValueTableProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <View style={styles.container}>
      <View style={styles.table}>
        {data.map((item, index) => (
          <View
            key={`${item.label}-${index}`}
            style={[styles.row, index !== data.length - 1 && styles.rowBorder]}>
            <View style={styles.keyCell}>
              <Text style={styles.keyText}>{item.label}</Text>
            </View>
            <View style={styles.valueCell}>
              <Text style={styles.valueText}>{item.value}</Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#4D4E57",
  },
  row: {
    flexDirection: "row",
    alignItems: "stretch",
  },
  rowBorder: {
    borderBottomWidth: 1,
    borderBottomColor: "#4D4E57",
  },
  keyCell: {
    flex: 1,
    paddingRight: IS_WEB ? 16 : tranformPx(16),
    borderRightWidth: 1,
    borderRightColor: "#4D4E57",
    padding: IS_WEB ? 18 : tranformPx(8),
    backgroundColor: IS_WEB ? "#2F3342" : "#202020",
    justifyContent: "center",
  },
  keyText: {
    fontSize: IS_WEB ? 14 : tranformPx(12),
    color: "#FFFFFF",
    lineHeight: IS_WEB ? 22 : tranformPx(18),
  },
  valueCell: {
    flex: 1,
    padding: IS_WEB ? 18 : tranformPx(8),
    justifyContent: "center",
  },
  valueText: {
    fontSize: IS_WEB ? 14 : tranformPx(12),
    lineHeight: IS_WEB ? 22 : tranformPx(18),
    color: "#FFFFFF",
  },
});
